import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export interface DropMenuPaneAttrs {
  header: string;
  'show-back-button'?: boolean;
}

export interface DropMenuPaneProps {
  attrs?: DropMenuPaneAttrs;
}

export class DropMenuPane extends Component<EmptyObj, DropMenuPaneAttrs> {
  static get attrsSchema(): AttrsSchema<DropMenuPaneAttrs> {
    return {
      header: `string`,
      'show-back-button': `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        clickedBackButton: () => this.dispatchEvent(new CustomEvent(`back-click`)),
      },
    };
  }
}

export const DropMenuPaneEl = defineAndMakeJsxFactory<DropMenuPaneProps>(`mp-drop-menu-pane`, DropMenuPane);
export const DropMenuPaneReact = panel2react<DropMenuPaneProps>(`mp-drop-menu-pane`, DropMenuPane);
